webpackJsonp([246449838016611],{

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/us-expertise.2a975ddd.jpg";

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _block = __webpack_require__(10);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockExpertise = function BlockExpertise(_ref) {
	  var imageUrl = _ref.imageUrl,
	      imageAlt = _ref.imageAlt,
	      pageTitle = _ref.pageTitle,
	      title = _ref.title,
	      children = _ref.children,
	      link = _ref.link;
	  return _react2.default.createElement(
	    _block2.default,
	    { hasDecoration: !!pageTitle, className: 'block-expertise' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-md-7 block-expertise-image mb-4 mb-md-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'decoration' },
	            _react2.default.createElement('img', { className: 'w-100 img-fluid block-content-image', src: imageUrl, alt: imageAlt })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-md-5 offset-md-1 block-expertise-content' },
	          _react2.default.createElement(
	            'p',
	            { className: 'block-expertise-title' },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'block-expertise-content-true' },
	            children
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: link, className: 'btn btn-primary' },
	            'Voir la galerie'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = BlockExpertise;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _block = __webpack_require__(10);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _myTitle = __webpack_require__(12);
	
	var _myTitle2 = _interopRequireDefault(_myTitle);
	
	var _blockCover = __webpack_require__(17);
	
	var _blockCover2 = _interopRequireDefault(_blockCover);
	
	var _blockExpertise = __webpack_require__(209);
	
	var _blockExpertise2 = _interopRequireDefault(_blockExpertise);
	
	var _usExpertise = __webpack_require__(517);
	
	var _usExpertise2 = _interopRequireDefault(_usExpertise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [
	/*{
	  imageUrl: '/expertise/sur-mesure.jpg',
	  imageAlt: 'Sur mesure',
	  title: 'Sur mesure',
	  content: (
	    <p>Nous réalisons dans notre atelier tout type de fabrication sur mesure. Faites nous part de votre projet.</p>
	  ),
	  link: '/realisations/sur-mesure'
	},*/
	{
	  imageUrl: '/expertise/cuisine.jpg',
	  imageAlt: 'Cuisine',
	  title: 'Cuisine',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'Votre cuisine customis\xE9e, avec fa\xE7ades et finitions faites main sur une base de caissons industriels pour une parfaite ma\xEEtrise de votre budget.'
	  ),
	  link: '/realisations/cuisine'
	}, {
	  imageUrl: '/expertise/salle-de-bain.jpg',
	  imageAlt: 'Salle de bain',
	  title: 'Salle de bain',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'La fabrication compl\xE8te de votre salle de bain en m\xE9lamin\xE9 hydrofuge parfaitement adapt\xE9, avec des fa\xE7ades sur mesure.'
	  ),
	  link: '/realisations/salle-de-bain'
	}, {
	  imageUrl: '/expertise/bibliotheque.jpg',
	  imageAlt: 'Bibliothèque',
	  title: 'Bibliothèque',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'Enti\xE8rement r\xE9alis\xE9e sur mesure selon vos envies, une biblioth\xE8que pleine d\u2019astuces qui peut m\xEAme int\xE9grer un \xE9clairage ou votre t\xE9l\xE9viseur.'
	  ),
	  link: '/realisations/bibliotheque'
	}, {
	  imageUrl: '/expertise/dressing.jpg',
	  imageAlt: 'Dressing et aménagement de placards',
	  title: 'Dressing et aménagement de placards',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'Une fabrication sur mesure pour optimiser votre espace et cr\xE9er un rangement parfaitement rationnel qui correspond \xE0 vos envies.'
	  ),
	  link: '/realisations/dressing-placard'
	}, {
	  imageUrl: '/expertise/tete-de-lit.jpg',
	  imageAlt: 'Tête de lit',
	  title: 'Tête de lit',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'L\u2019int\xE9gration harmonieuse de votre t\xEAte de lit avec lumi\xE8re et rangement \xE0 fa\xE7on pour parfaire l\u2019esth\xE9tique de votre chambre \xE0 coucher.'
	  ),
	  link: '/realisations/tete-de-lit'
	}, {
	  imageUrl: '/expertise/escalier-beton.jpg',
	  imageAlt: 'Habillage escalier',
	  title: 'Habillage escalier',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'L\u2019esth\xE9tique chaleureuse et la long\xE9vit\xE9 exceptionnelle d\u2019un habillage sur mesure en ch\xEAne massif de premi\xE8re qualit\xE9.'
	  ),
	  link: '/realisations/escalier'
	}, {
	  imageUrl: '/expertise/parquet.jpg',
	  imageAlt: 'Parquet',
	  title: 'Parquet',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'Un tr\xE8s vaste choix de bois et de techniques de pose pour un sol aussi beau que r\xE9sistant, dont vous profiterez tr\xE8s longtemps.'
	  ),
	  link: '/realisations/parquet'
	}, {
	  imageUrl: '/expertise/terrasse.jpg',
	  imageAlt: 'Terrasse',
	  title: 'Terrasse',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'Une construction durable, r\xE9alis\xE9e \xE0 partir des plus beaux bois, pour profiter toute l\'ann\xE9e de votre jardin et de votre terrasse.'
	  ),
	  link: '/realisations/terrasse'
	}, {
	  imageUrl: '/expertise/divers.jpg',
	  imageAlt: 'Aménagement divers',
	  title: 'Aménagement divers',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'La r\xE9alisation sur mesure de vos demandes les plus sp\xE9cifiques gr\xE2ce \xE0 un \xE9change de chaque instant sur les solutions les plus adapt\xE9es.'
	  ),
	  link: '/realisations/divers'
	}, {
	  imageUrl: '/expertise/ebenisterie.jpg',
	  imageAlt: 'Ébénisterie',
	  title: 'Ébénisterie',
	  content: _react2.default.createElement(
	    'p',
	    null,
	    'Les plus nobles essences, les plus beaux bois et la ma\xEEtrise parfaite de leur travail pour cr\xE9er sur mesure tout ce qui vous tient \xE0 c\u0153ur.'
	  ),
	  link: '/realisations/ebenisterie'
	}];
	
	var Expertise = function Expertise() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Didier Br\xE9 : Meubles sur mesure, menuiserie et \xE9b\xE9nisterie'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'r\xE9alisation de tout type de meuble sur mesure' })
	    ),
	    _react2.default.createElement(_blockCover2.default, {
	      backgroundUrl: _usExpertise2.default,
	      title: 'Nos expertises',
	      repeatedTitle: true }),
	    _react2.default.createElement(
	      _block2.default,
	      { hasDecoration: true },
	      _react2.default.createElement(
	        _myTitle2.default,
	        { small: true },
	        'Ce que nous faisons'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'expertise-list' },
	      data.map(function (item, index) {
	        return _react2.default.createElement(
	          _blockExpertise2.default,
	          _extends({}, item, { key: index }),
	          item.content
	        );
	      })
	    )
	  );
	};
	
	exports.default = Expertise;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-expertise-js-516a3f7677b7aabb4401.js